"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_placeholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192 192",
    style: {
      enableBackground: "new 0 0 192 192"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#666666;}\n\t.st2{fill:#E60000;}\n"), /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic_mid"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,176c-44.1,0-80-35.9-80-80s35.9-80,80-80s80,35.9,80,80S140.1,176,96,176z M96,20c-41.9,0-76,34.1-76,76 c0,41.9,34.1,76,76,76c41.9,0,76-34.1,76-76C172,54.1,137.9,20,96,20z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,166c-1.1,0-2-0.9-2-2V28c0-1.1,0.9-2,2-2s2,0.9,2,2v136C98,165.1,97.1,166,96,166z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164,98H28c-1.1,0-2-0.9-2-2s0.9-2,2-2h136c1.1,0,2,0.9,2,2S165.1,98,164,98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.7,153c-0.5,0-1-0.2-1.4-0.6c-0.8-0.8-0.8-2,0-2.8L149.6,39.2c0.8-0.8,2-0.8,2.8,0c0.8,0.8,0.8,2,0,2.8 L42.1,152.4C41.7,152.8,41.2,153,40.7,153z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.2,152.8c-0.5,0-1-0.2-1.4-0.6L39.6,42.1c-0.8-0.8-0.8-2,0-2.8c0.8-0.8,2-0.8,2.8,0l110.1,110.1 c0.8,0.8,0.8,2,0,2.8C152.2,152.6,151.7,152.8,151.2,152.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164,166H28c-1.1,0-2-0.9-2-2V28c0-1.1,0.9-2,2-2h136c1.1,0,2,0.9,2,2v136C166,165.1,165.1,166,164,166z  M30,162h132V30H30V162z"
  }))));
}

var _default = ic_placeholder;
exports.default = _default;